import {
  CButton,
  CCardHeader,
  CCol,
  CDataTable,
  CInputGroup,
  CLabel,
  CRow,
  CSpinner,
} from "@coreui/react";
import React, { useState } from "react";
import { apiCall } from "src/_apiConfig/apiCall";
import csvFile from "../../assets/files/Bidder.csv";
const Ibeslist = () => {
  const [loading, setloading] = useState(false);
  const [loadingForUpload, setloadingForUpload] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [usersData, setuserData] = useState();
  const [distplayStatus, setdistplayStatus] = useState(false);
  const [disableBtn, setdisableBtn] = useState(true);
  const [uploadBtn, setuploadBtn] = useState(false);
  const [validMsg, setvalidMsg] = useState("");

  const validateData = async () => {
    let duplicated = false;
    setloading(true);
    // const file = document.getElementById("inputGroupFile01");
    const header = new Headers();
    //header.append("", "");
    const data = new FormData();

    data.append("file", selectedFile);
    const response = await apiCall(
      `Bidder/ValidateUpload`,
      "POST",
      header,
      data
    );
    const jsonobj = await response.json();
    if (response.status === 200) {
      setuserData(jsonobj);
      setdistplayStatus(true);
      setdisableBtn(true);
      setloading(false);
      setvalidMsg("");
      console.log(jsonobj.find((e) => e.status !== "Success"));
      if (
        jsonobj.find(
          (e) => e.status !== "Success" && e.status !== "Update Record"
        )
      ) {
        // jsonobj.find((e) => e.status === "abcd")
        duplicated = true;
        setuploadBtn(false);
      } else {
        // eslint-disable-next-line no-unused-vars
        duplicated = false;
        setuploadBtn(true);
      }
    } else if (response.status === 400) {
      setloading(false);
      setvalidMsg("Please insert correct file.");
      setdisableBtn(true);
    } else if (response.status >= 499) {
      setloading(false);
      setdisableBtn(true);
      setvalidMsg("please select file ");
    } else if (data.append("file", selectedFile) === null) {
      setdisableBtn(true);
    } else {
      setloading(false);
      setuserData("");
    }
  };

  const UploadData = async () => {
    setloadingForUpload(true);
    const header = new Headers();
    const uploadData = new FormData();
    uploadData.append("file", selectedFile);
    header.append("Accept", "application/json");
    const uploadResponse = await apiCall(
      `Bidder/Upload`,
      "POST",
      header,
      uploadData
    );
    await uploadResponse.json();
    if (uploadResponse.statusText === "OK") {
      // setuserData(uploadjsonobj)
      setdistplayStatus(false);
      setdisableBtn(true);
      setloadingForUpload(false);
      setuploadBtn(false);
    } else {
      setdistplayStatus(false);
      setloadingForUpload(false);
      setuploadBtn(false);
    }
  };
  const changeHandler = (e) => {
    setSelectedFile(e.target.files[0]);
    setdisableBtn(false);
  };
  const changeUploadHandler = (e) => {
    setSelectedFile(e.target.files[0]);
  };
  const fields = [
    {
      key: "srNo",
      label: "Sr No",
    },
    {
      key: "ShowSpan",
      label: <div>Status</div>,
      _style: { width: "50px" },
    },
    {
      key: "accountNumber",
      label: "accountNumber",
    },
    {
      key: "emailId",
      label: "Email Id",
    },

    {
      key: "alternateEmail",
      label: "alternateEmail",
    },
    {
      key: "bankAccountType",
      label: "Proprietor Name",
    },
    {
      key: "bankBranch",
      label: "bankBranch",
    },
    {
      key: "emdAmount",
      label: "emdAmount",
    },
    {
      key: "ifscCode",
      label: "ifscCode",
    },
    {
      key: "disctrict",
      label: "disctrict",
    },

    {
      key: "city",
      label: "city",
    },
    {
      key: "area",
      label: "area",
    },
    {
      key: "pincode",
      label: "pincode",
    },
    {
      key: "houseNo",
      label: "houseNo",
    },
    {
      key: "state",
      label: "state",
    },
    {
      key: "contact1",
      label: "contact1",
    },
    {
      key: "contact2",
      label: "contact2",
    },
    {
      key: "mobile",
      label: "mobile",
    },
    {
      key: "fax",
      label: "fax",
    },
    {
      key: "username",
      label: "username",
    },
    {
      key: "pan",
      label: "pan",
    },
    {
      key: "proprietor_name",
      label: "proprietor_name",
    },
    {
      key: "proprietor_name1",
      label: "proprietor_name1",
    },
    {
      key: "proprietor_name2",
      label: "proprietor_name2",
    },
    {
      key: "proprietor_name3",
      label: "proprietor_name3",
    },
    {
      key: "proprietor_name4",
      label: "proprietor_name4",
    },
    {
      key: "proprietor_name5",
      label: "proprietor_name6",
    },
    {
      key: "proprietor_name6",
      label: "proprietor_name6",
    },
    {
      key: "proprietor_name7",
      label: "proprietor_name7",
    },
    {
      key: "proprietor_name8",
      label: "proprietor_name8",
    },
    {
      key: "biddingCapacity",
      label: "biddingCapacity",
    },
    {
      key: "companyName",
      label: "companyName",
    },
    {
      key: "companyType",
      label: "companyType",
    },
    {
      key: "company_Category",
      label: "company_Category",
    },
    {
      key: "due",
      label: "due",
    },
    {
      key: "gst",
      label: "gst",
    },
    {
      key: "registeredDistrict",
      label: "registeredDistrict",
    },
    {
      key: "purchaseCapacity",
      label: "purchaseCapacity",
    },
    {
      key: "registrationDetails",
      label: "registrationDetails",
    },
    {
      key: "streetName",
      label: "streetName",
    },
  ];

  return (
    <>
      <CCardHeader className="mb-3 shadow-sm">
        <CRow className="pt-3" xl={12}>
          <CCol xl={10}>
            <h3>Import Bidder - Excel Sheet</h3>
          </CCol>
        </CRow>
        <hr />
        <CRow className="mb-3">
          <CCol xl={2}>
            <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
              Bidder Excel Sheet
            </CLabel>
          </CCol>
          <CCol xl={4}>
            <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  onChange={
                    distplayStatus ? changeUploadHandler : changeHandler
                  }
                  id="inputGroupFile01"
                  type="file"
                  accept=".csv"
                  className="custom-file-input"
                />
                <label
                  className="custom-file-label "
                  htmlFor="inputGroupFile01"
                >
                  {selectedFile ? selectedFile.name : <>Choose file</>}
                </label>
              </div>
            </CInputGroup>
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-1">
          <CCol>
            {loading ? (
              <CSpinner className="spinner-grow" color="success" />
            ) : (
              <CButton
                color="success"
                onClick={validateData}
                disabled={disableBtn}
              >
                Import
              </CButton>
            )}
            {loadingForUpload ? (
              <CSpinner className="spinner-grow ml-3" color="success" />
            ) : (
              <CButton
                className="ml-3"
                color="success"
                onClick={UploadData}
                disabled={uploadBtn === false ? true : false}
              >
                Upload
              </CButton>
            )}

            <a href={csvFile} download="Sample Bidder.csv">
              <CButton className="ml-3" color="info">
                Sample File
              </CButton>
            </a>
          </CCol>
        </CRow>
        <div className="customRedFont"> {validMsg}</div>

        {distplayStatus ? (
          <div className="scrollbar">
            <CDataTable
              fields={fields}
              items={usersData}
              responsive
              border
              scopedSlots={{
                ShowSpan: (item, index) => {
                  if (
                    item.status === "Success" ||
                    item.status === "Update Record"
                  )
                    return (
                      <td>
                        <span className="customGreenFont">{item.status}</span>
                      </td>
                    );
                  //if (item.status !== "Success" && item.status !== "Update Record")
                  else
                    return (
                      <td>
                        <span className="customRedFont">{item.status}</span>
                      </td>
                    );
                },
              }}
            />
          </div>
        ) : (
          <></>
        )}
      </CCardHeader>
    </>
  );
};

export default Ibeslist;
